import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HubVideo() {
  const { slug } = useParams();
  const [video, setVideo] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/hub/${slug}`)
      .then((r) => {
        if (!active) return;
        setVideo(r.data);
        setStatus("ok");
        document.title = `${r.data.title} — aponiqo Hub`;
      })
      .catch(() => active && setStatus("notfound"));
    return () => {
      active = false;
    };
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#0a2540] text-white" data-testid="hub-video-page">
      <header className="flex items-center justify-center border-b border-white/10 px-6 py-5">
        <img src="/logo_aponiqo_light.png" alt="aponiqo" className="h-8 w-auto" data-testid="hub-logo" />
      </header>

      <main className="mx-auto flex max-w-3xl flex-col px-5 py-10 sm:py-14">
        {status === "loading" && (
          <div className="flex flex-col items-center gap-3 py-24 text-white/70" data-testid="hub-loading">
            <Loader2 className="h-8 w-8 animate-spin" />
            <p>Video laden…</p>
          </div>
        )}

        {status === "notfound" && (
          <div className="flex flex-col items-center gap-3 py-24 text-center text-white/70" data-testid="hub-notfound">
            <AlertCircle className="h-10 w-10 text-white/40" />
            <h1 className="text-xl font-semibold text-white">Video niet gevonden</h1>
            <p className="max-w-md text-sm">Deze video bestaat niet (meer). Controleer de link of scan de NFC-pod opnieuw.</p>
          </div>
        )}

        {status === "ok" && video && (
          <div className="animate-in fade-in duration-500">
            <div className="overflow-hidden rounded-2xl border border-white/10 bg-black shadow-2xl">
              <video
                key={slug}
                controls
                autoPlay
                playsInline
                controlsList="nodownload"
                className="aspect-video w-full bg-black"
                src={`${API}/hub/${slug}/stream`}
                data-testid="hub-video-player"
              />
            </div>
            <h1 className="mt-8 font-heading text-3xl font-bold tracking-tight sm:text-4xl" data-testid="hub-video-title">
              {video.title}
            </h1>
            {video.description && (
              <p className="mt-4 whitespace-pre-line text-base leading-relaxed text-white/75" data-testid="hub-video-description">
                {video.description}
              </p>
            )}
          </div>
        )}
      </main>

      <footer className="mt-auto px-6 py-8 text-center text-xs text-white/40">
        Aangeboden door aponiqo
      </footer>
    </div>
  );
}
